import { Button } from "@/components/ui/button";
import { useNotificactionStore } from "@/containers/Mail/store/notitication-store";
import { useMarkRead } from "@/containers/Mail/hooks/use-mark-read";
import { MailIcon } from "@/components/ui/icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { useHistory } from "react-router-dom";

const InboxNotification = () => {
  const { messages } = useNotificactionStore();
  const { markAsRead } = useMarkRead();
  const history = useHistory();

  const handleViewMessage = (message: any) => {
    markAsRead(message.id);
    
    history.push(`/leads/detail/${message.lead_id}?messageId=${message.id}`);
  };

  if (messages.length > 0) {
    return (
      <div className="px-4 py-2 max-h-[60vh] overflow-y-auto">
        <div className="flex flex-col gap-3">
          {messages.map((message) => (
            <div
              key={message.id}
              className="group border border-border/50 rounded-lg p-1 hover:border-primary/30 hover:bg-accent/30 transition-all duration-200"
            >
              <div className="flex items-start gap-3">
                <div className="mt-0.5 shrink-0">
                  <div className="bg-primary/10 rounded-full p-1">
                    <HugeiconsIcon
                      icon={MailIcon}
                      size={16}
                      className="text-primary"
                    />
                  </div>
                </div>
                <div className="flex-1 space-y-2 min-w-0">
                  <div className="text-sm text-muted-foreground">
                    Lead:{" "}
                    <span className="font-semibold text-primary">
                      {message.lead_name || "Unknown"}
                    </span>
                  </div>
                  <div className="text-sm">
                    <span className="text-muted-foreground">From:</span>{" "}
                    <span className="font-medium text-foreground truncate block">
                      {message.from}
                    </span>
                  </div>
                  <div className="text-sm">
                    <span className="text-muted-foreground">Subject:</span>{" "}
                    <span className="font-medium text-foreground truncate block">
                      {message.subject || "(No subject)"}
                    </span>
                  </div>
                  <div className="pt-2 flex justify-end">
                    <Button
                      size="sm"
                      variant="outline"
                      className="w-full sm:w-auto"
                      onClick={() => handleViewMessage(message)}
                    >
                      View Message
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-center gap-2">
        <div className="py-12 flex items-center justify-center flex-col gap-2">
          <div className="bg-primary/10 rounded-full p-1 max-w-max">
            <HugeiconsIcon
              icon={MailIcon}
              size={42}
              className="text-primary"
            />
          </div>
          <div className="text-sm text-muted-foreground">
            There is not any unread message in your inbox.
          </div>
        </div>
      </div>
    </div>
  );
};

export { InboxNotification };
